const SelfScreen = ({img}) => {
	return (
		<div className='selfScreenImgDiv'>
			<img className='selfScreenImg' src={img} alt='self' />
		</div>
	)
}

export default SelfScreen